export const SHEET_PRESETS = [
  {
    id: "full",
    i18nKey: "full",
    length: 2440,
    width: 1220,
  },
  {
    id: "half",
    i18nKey: "half",
    length: 1220,
    width: 610,
  },
  {
    id: "large",
    i18nKey: "large",
    length: 2500,
    width: 1250,
  },
  {
    id: "panel",
    i18nKey: "panel",
    length: 1830,
    width: 750,
  },
];

export const PRIMARY_SHEET_PRESET_IDS = ["full", "half"];

export function getPrimarySheetPresets() {
  return SHEET_PRESETS.filter((preset) => PRIMARY_SHEET_PRESET_IDS.includes(preset.id));
}

export function getMoreSheetPresets() {
  return SHEET_PRESETS.filter((preset) => !PRIMARY_SHEET_PRESET_IDS.includes(preset.id));
}

export function isActiveSheetPreset(sourcePanel, preset) {
  return Number(sourcePanel.length) === preset.length && Number(sourcePanel.width) === preset.width;
}

export function resolveSheetPreset(preset, display) {
  const base = `web.presets.sheet.${preset.i18nKey}`;
  const hintKey = `${base}.hint`;
  const hintLookup = display.t(hintKey);
  return {
    ...preset,
    label: display.formatSheet(preset.length, preset.width),
    hint: hintLookup !== hintKey ? hintLookup : undefined,
  };
}
